import { render, staticRenderFns } from "./cable-details-form.component.vue?vue&type=template&id=8804b938"
import script from "./cable-details-form.component.ts?vue&type=script&lang=ts&external"
export * from "./cable-details-form.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports